.brandButton {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  padding: 0;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0.088px;
  color: #ffffff;
  border-radius: 30px;
  font-weight: 700;
  text-transform: lowercase;
  cursor: pointer;

  p::first-letter {
    text-transform: capitalize;
  }

  img {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translate(0, -50%);
    width: 20px;
    height: 20px;
    object-fit: contain;
    z-index: 5;
  }

  @at-root html[lang='ru'] & {
    font-size: 22px;
  }

  &Content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--ed-brand, #ae66f6);
      border-radius: 30px;
      z-index: -1;
      box-shadow: 0px 10px 20px rgb(0 0 0 / 30%);
      transition: 0.3s;
    }
  }

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

  &__animate::before,
  &__animate::after {
    content: '';
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    display: block;
    height: 100%;
    width: 100%;
    background: var(--ed-brand, #ae66f6);
    border-radius: 30px;
    opacity: 0.4;
    transition: 0.3s;
  }

  &__animate::before {
    animation: pulse1 0.8s * 1.5 cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite both;
  }

  &__animate::after {
    animation: pulse2 0.8s * 1.5 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite both;
  }

  @keyframes pulse1 {
    0% {
      opacity: 0.8;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.07, 1.3);
    }
  }

  @keyframes pulse2 {
    0% {
      opacity: 0.8;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.035, 1.2);
    }
  }
}

.brandButton.noShadows {
  .brandButtonContent::before {
    box-shadow: none;
  }
}

.brandButton:hover {
  .brandButtonContent::before {
    background: var(--ed-brand, #9d50d5);
  }
}

.brandButton__animate:hover::before,
.brandButton__animate:hover::after {
  background: var(--ed-brand, #9d50d5);
}

.brandButton:active {
  .brandButtonContent::before {
    background: var(--ed-brand, #7d39ae);
  }
}

.brandButton__animate:active::before,
.brandButton__animate:active::after {
  background: var(--ed-brand, #7d39ae);
}
